import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from '../../services/http.service';
import { SnackBarService } from '../../services/snack-bar.service';
import { AppService } from '../../services/app.service';
import { QuoteService } from '../../services/quote.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-feedback-dialog',
    templateUrl: './feedback-dialog.component.html',
    styleUrls: ['./feedback-dialog.component.scss'],
})
export class FeedbackDialogComponent {
    public emailValue: string;
    public subjectValue: string;
    public messageValue: string;
    public isLoading = false;

    constructor(
        private snackBarService: SnackBarService,
        private translateService: TranslateService,
        private http: HttpService,
        private appService: AppService,
        public dialogRef: MatDialogRef<FeedbackDialogComponent>,
        private quoteService: QuoteService
    ) {}

    public sendFeedback(): void {
        const payload = {
            sender: this.emailValue,
            subject: this.getSubject(),
            message: this.messageValue,
            salesOrg: this.appService.getSalesOrg(),
        };
        const url = `${environment.http.baseUrl}feedback`;
        this.isLoading = true;
        this.http.post(url, payload).subscribe({
            next: () => {
                this.snackBarService.openSnackBar({
                    message: this.translateService.instant('FEEDBACK_DIALOG.SENDING_FEEDBACK.SUCCESS_MSG'),
                    isFailure: false,
                });
                this.dialogRef.close();
                this.isLoading = false;
            },
            error: () => {
                this.snackBarService.openSnackBar({
                    message: this.translateService.instant('FEEDBACK_DIALOG.SENDING_FEEDBACK.ERROR_MSG'),
                    isFailure: true,
                });
                this.isLoading = false;
            },
        });
    }

    private getSubject() {
        if (this.quoteService.getCurrentQuote()) {
            const { quickRef: qRef, customerNumber: customer } = this.quoteService.getCurrentQuote();
            const subject = this.subjectValue;
            return this.translateService.instant('FEEDBACK_DIALOG.PRE_FILLED_SUBJECT', { subject, qRef, customer });
        }
        return this.subjectValue;
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}
